import { generatePath, matchPath, NavigateFunction } from "react-router-dom";

import { PATIENT_STATUS } from "~/common/constants";
import { isPatientActive, PatientStatus } from "~/common/utils";
import {
  BASE_LEAD_PATIENT_PROFILE_PATH,
  BASE_PATIENT_PROFILE_PATH,
  CONSULTATION_PATH,
  ROUTES,
} from "~/providers/router";

export interface MenuOptionData {
  label: string;
  onClick: () => void;
  value?: string;
  notificationAmount?: number;
  current?: boolean;
  enabled?: boolean;
}

export const getPatientProfileMenuOptions = (
  navigate: NavigateFunction,
  patientId: string,
  patientStatus: PatientStatus,
  has_consultation = false,
  has_zoom_integration = false,
): MenuOptionData[] => {
  const actualPath = window.location.pathname;
  const isActivePatient = isPatientActive(patientStatus);

  const patientInfoRoute = isActivePatient
    ? ROUTES.patientInfo
    : ROUTES.patientConsultationInfo;

  const consultationRoute = isActivePatient
    ? ROUTES.patientPreview
    : ROUTES.consultationPreview;

  const activityFeedRoute =
    patientStatus !== PATIENT_STATUS.active
      ? ROUTES.leadPatientActivityFeed
      : ROUTES.activePatientActivityFeed;

  return [
    {
      label: "Activity feed",
      current: !!matchPath(activityFeedRoute, actualPath),
      onClick: () =>
        navigate(
          generatePath(activityFeedRoute, {
            patientId: patientId,
          }),
        ),
      enabled: true,
    },
    {
      label: "Medications",
      current: !!matchPath(ROUTES.medication, actualPath),
      onClick: () =>
        navigate(
          generatePath(ROUTES.medication, {
            patientId: patientId,
          }),
        ),
      enabled: isActivePatient,
    },
    {
      label: "Orders",
      current: !!matchPath(ROUTES.orders, actualPath),
      onClick: () =>
        navigate(
          generatePath(ROUTES.orders, {
            patientId: patientId,
          }),
        ),
      enabled: isActivePatient,
    },
    {
      label: "Consultation",
      current:
        !!matchPath(
          `${BASE_PATIENT_PROFILE_PATH}${CONSULTATION_PATH}/*`,
          actualPath,
        ) ||
        !!matchPath(
          `${BASE_LEAD_PATIENT_PROFILE_PATH}${CONSULTATION_PATH}/*`,
          actualPath,
        ),
      onClick: () => navigate(generatePath(consultationRoute, { patientId })),
      enabled: has_consultation,
    },
    {
      label: "Sessions",
      current:
        !!matchPath(ROUTES.sessions, actualPath) ||
        !!matchPath({ path: ROUTES.sessionDetail, end: false }, actualPath),
      onClick: () => navigate(generatePath(ROUTES.sessions, { patientId })),
      enabled: isActivePatient && has_zoom_integration,
    },
    {
      label: "Patient info",
      current: !!matchPath(patientInfoRoute, actualPath),
      onClick: () =>
        navigate(
          generatePath(patientInfoRoute, {
            patientId: patientId,
          }),
        ),
      enabled: true,
    },
  ];
};
